<template>
  <div class="body-wrapper">
    <Header :title="'Content Manager'" />
    
    <div class="tab-container">
      <ul class="tabs">
        <li 
          :class="{'selected': selectedTab === 'all'}"
          @click="changeTab('all')">
          ALL CONTENT
        </li>
        <li 
          :class="{'selected': selectedTab === 'app'}"
          @click="changeTab('app')">
            APP
        </li>
        <li 
          :class="{'selected': selectedTab === 'website'}"
          @click="changeTab('website')">
            WEBSITE
        </li>
        <li 
          :class="{'selected': selectedTab === 'blogs'}"
          @click="changeTab('blogs')">
            BLOGS
        </li>
      </ul>
      <div class="tab-body">
        <div class="tab" v-if="selectedTab === 'all'">
          <div 
            class="content-row" 
            v-for="category in categories" 
            :key="category.id" 
            @click="loadDetails(category)">
              <img src="../assets/computer.svg"/>
              <div class="details">
                <h3>{{ getTitle(category['doc_type']) }}</h3>
                <span>LAST UPDATE: {{ formatDate(category['updated_at']) }}</span>
              </div>
          </div>
        </div>
        <div class="tab" v-if="selectedTab === 'app'">
          
        </div>
        <div class="tab" v-if="selectedTab === 'website'">
          
        </div>
        <div class="tab" v-if="selectedTab === 'blogs'">
          <button class="secondary-btn-dark" @click="createNew">NEW BLOG POST</button>
          <div 
            class="content-row" 
            v-for="blog in blogs" 
            :key="blog.id">
            <img src="../assets/computer.svg"/>
            <div class="details">
              <h3>{{ blog.title }}</h3>
              <span>{{ blog.slug }}</span>
            </div>
            <button class="secondary-btn-dark edit-btn" @click="loadBlog(blog.id)">EDIT</button>
            <button class="secondary-btn-dark" @click="deleteBlogClicked(blog.id)">DELETE</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/header/Header";
import { getDocuments, getBlogs, deleteBlog } from "@/api/requests";
import { formatDateTime } from '@/utils'

export default {
  name: "ContentEditor",

  data() {
    return {
      selectedTab: 'all',
    };
  },

  components: {
    Header,
  },

  async mounted() {
    getDocuments().then(response => {
      this.$store.dispatch('content/setList', response.data);
    }).catch(() => {
      // TODO errors
    });
  },

  methods: {
    formatDate(date) {
      return formatDateTime(date);
    },

    loadBlogs() {
      getBlogs().then(response => {
        this.$store.dispatch('content/setBlogs', response.data);
      }).catch(() => {
        // TODO errors
      });
    },

    changeTab(tab) {
      this.selectedTab = tab;

      if (tab == 'blogs') {
        this.loadBlogs();
      }
    },

    getTitle(type) {
      switch (type) {
        case 'privacy':
          return 'PRIVACY POLICY';
        case 'terms':
          return 'TERMS & CONDITIONS';
        case 'goals':
          return 'APP GOALS';
        case 'interests':
          return 'APP INTERESTS';
        case 'about':
          return 'ABOUT WOTIVE';
        default:
          break;
      }
    },

    loadDetails(category) {
      this.$router.push({ name: 'ContentEditorDetails', params: { type: category.doc_type },  query: { content: category.content_type } })
    },

    createNew() {
      this.$router.push({ name: 'ContentEditorDetails', params: { type: 'new_blog' },  query: { content: 'new_blog' } })
    },

    loadBlog(blogId) {
      this.$router.push({ name: 'ContentEditorDetails', params: { type: 'blog', blogId: blogId } })
    },

    deleteBlogClicked(blogId) {
      this.$confirm(
        "Are you sure you want to delete this blog?", 
        "DELETE BLOG").then(() => {
          deleteBlog(blogId).then(() => {
            this.$store.commit('content/deleteBlog', blogId);
            this.$toasted.global.app_success({
              message: "Blog has been deleted."
            });
          });
        }).catch(() => {
          this.$toasted.global.app_error({
            message: "Failed to delete blog."
          });
        });
    }
  },

  computed: {
    categories() {
      return this.$store.state.content.categories;
    },
    
    blogs() {
      return this.$store.state.content.blogs;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";
@import "@/assets/css/internal";

.tab-container {
  padding: $spacing-base;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    height: 28px;
    margin-bottom: $spacing-base;
    
    li {
      float: left;
      padding-left: $spacing-large;
      padding-right: $spacing-large;
      padding-bottom: $spacing-small;
      border-bottom: 3px solid $sec1;
      color: $sec1;
      font-weight: bold;
      font-size: $font-size-base;
      user-select: none;
      cursor: pointer;
    }

    .selected {
      color: $blue;
      border-color: $blue;
    }
  }

  .tab-body {
    height: calc(100vh - 200px);
    overflow-y: scroll;
  }
}

.content-row {
  background: $sec0;
  max-width: 600px;
  display: flex;
  margin-top: $spacing-small;
  align-items: center;
    
  img {
    padding: $spacing-small;
  }

  .details {
    flex: 1;
    padding: $spacing-small;
    padding-left: 0;
    cursor: pointer;

    h3 {
      padding: 0;
      margin: 0;
      font-size: $font-size-medium;
      font-weight: bold;
      text-transform: uppercase;
      color: #FFF;
    }

    span {
      font-size: $font-size-small;
      color: $sec5;
      text-transform: uppercase;
      text-overflow: ellipsis;
    }

  }
  button {
    width: 100px;
    height: 28px;
    margin-right: 8px;
  }
  .edit-btn {
    color: $blue;
    border: 1px solid $blue;
  }
}

</style>
